import { render, staticRenderFns } from "./ColorSettings.vue?vue&type=template&id=73e63248&scoped=true&"
import script from "./ColorSettings.vue?vue&type=script&lang=js&"
export * from "./ColorSettings.vue?vue&type=script&lang=js&"
import style0 from "./ColorSettings.vue?vue&type=style&index=0&id=73e63248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e63248",
  null
  
)

export default component.exports